import { CircleAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';
import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';

interface RequestErrorStateProps {
  /** 按需展示标题，message 在标题下作为说明，缺省时保留单段提示 */
  title?: string;
  message?: string;
  onRetry: () => void;
  retrying?: boolean;
  className?: string;
  'aria-label'?: string;
}

/** 统一局部错误展示，失败判断和重试逻辑由调用方负责 */
export function RequestErrorState({
  title,
  message = '数据加载失败，请稍后重试',
  onRetry,
  retrying = false,
  className,
  'aria-label': ariaLabel,
}: RequestErrorStateProps) {
  return (
    <Empty
      role="alert"
      aria-label={ariaLabel}
      className={cn('min-h-40 w-full flex-none gap-3 rounded-none p-6 md:p-6', className)}
    >
      <EmptyHeader>
        <EmptyMedia className="mb-0 text-muted-foreground">
          <CircleAlert className="size-6" />
        </EmptyMedia>
        {title && <EmptyTitle>{title}</EmptyTitle>}
        <EmptyDescription>{message}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button
          type="button"
          variant="outline"
          onClick={onRetry}
          disabled={retrying}
          aria-busy={retrying}
        >
          {retrying && <Spinner data-icon="inline-start" />}
          重试
        </Button>
      </EmptyContent>
    </Empty>
  );
}
